// TODO keep in sync with BE file
export const UnlimitedPlanLimits = {
    warning: 50,
    stop: 80
};
